import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideLogOut, lucideSettings, lucideUser } from '@ng-icons/lucide';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmDropdownMenuImports } from '@spartan-ng/helm/dropdown-menu';
import { AuthService } from '../../../../services/auth.service';
import { Company } from '../../../../services/company.service';

/** Account dropdown (desktop). */
@Component({
  selector: 'app-user-menu',
  imports: [RouterLink, NgIcon, HlmButtonImports, HlmDropdownMenuImports],
  providers: [provideIcons({ lucideLogOut, lucideSettings, lucideUser })],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button
      hlmBtn
      variant="outline"
      size="icon"
      class="rounded-full"
      [hlmDropdownMenuTrigger]="menu"
      align="end"
      aria-label="Konto-Menü">
      <ng-icon name="lucideUser" />
    </button>

    <ng-template #menu>
      <hlm-dropdown-menu class="w-56">
        <hlm-dropdown-menu-label>
          {{ company().name }}
        </hlm-dropdown-menu-label>
        <hlm-dropdown-menu-label class="font-normal">
          ID: {{ company().public_id }}
        </hlm-dropdown-menu-label>

        <div hlmDropdownMenuSeparator></div>

        <hlm-dropdown-menu-group>
          <a hlmDropdownMenuItem routerLink="/settings" [queryParams]="{ tab: 'company' }">
            <ng-icon name="lucideSettings" />
            Account
          </a>
          <button hlmDropdownMenuItem variant="destructive" (click)="logout()">
            <ng-icon name="lucideLogOut" />
            Logout
          </button>
        </hlm-dropdown-menu-group>
      </hlm-dropdown-menu>
    </ng-template>
  `,
})
export class UserMenuComponent {
  private readonly authService = inject(AuthService);

  readonly company = input.required<Company>();

  protected logout(): void {
    this.authService.logout();
  }
}
